import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { CategoriesSelectedTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackCategoriesSelectedFunction {
  (): void;
}

interface UseTrackCategoriesSelectedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackCategoriesSelectedFunction {
  (agrs: UseTrackCategoriesSelectedFunctionArgs): TrackCategoriesSelectedFunction;
}

const useTrackCategoriesSelected: UseTrackCategoriesSelectedFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<CategoriesSelectedTrackingEvent>();

  const trackCategoriesSelected: TrackCategoriesSelectedFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.CATEGORIES_SELECTED,
      eventCategory: TrackingEventCategory.LOOK_IN,
      store: country,
      section: PROJECT,
      segment,
      tradename,
      userId,
      userUuid: userId,
    });
  }, [country, emitUserEvent, segment, tradename, userId]);

  return trackCategoriesSelected;
};

export { useTrackCategoriesSelected };
